
export default (args: {dispatchDataV2: any}) => (candidacy: any) => {
  return args.dispatchDataV2({
    type: "ADD_CANDIDACY",
    value: candidacy
  })
}